import type { SedrRoomSummary } from '../../api/sedr';

export const SEDR_DELETION_PENDING_CHANGED = 'shareweb:sedr-deletion-pending-changed';

/** Notify chrome (nav badge) that pending deletion approvals may have changed. */
export function notifySedrDeletionPendingChanged(): void {
  window.dispatchEvent(new Event(SEDR_DELETION_PENDING_CHANGED));
}

/** True when the current admin must approve/reject another admin's deletion request. */
export function isPendingSedrDeletionApproval(
  room: Pick<SedrRoomSummary, 'archivedAt' | 'lifecycleState' | 'permission' | 'deletionRequestedBy'>,
  currentUserId: string,
): boolean {
  if (room.archivedAt) return false;
  return (
    room.lifecycleState === 'DeletionRequested' &&
    room.permission === 'Admin' &&
    Boolean(room.deletionRequestedBy) &&
    room.deletionRequestedBy !== currentUserId
  );
}

export function countPendingSedrDeletionApprovals(
  rooms: ReadonlyArray<
    Pick<SedrRoomSummary, 'archivedAt' | 'lifecycleState' | 'permission' | 'deletionRequestedBy'>
  >,
  currentUserId: string,
): number {
  let count = 0;
  for (const room of rooms) {
    if (isPendingSedrDeletionApproval(room, currentUserId)) count += 1;
  }
  return count;
}
